// ✅ Add Selectors
export const selectAddEmployeeData = (state) => state?.employees?.addEmployee?.data;
export const selectAddEmployeeLoading = (state) => state?.employees?.addEmployee?.loading;
export const selectAddEmployeeError = (state) => state?.employees?.addEmployee?.error;

// ✅ Update Selectors
export const selectUpdateEmployeeData = (state) => state?.employees?.updateEmployee?.data;
export const selectUpdateEmployeeLoading = (state) => state?.employees?.updateEmployee?.loading;
export const selectUpdateEmployeeError = (state) => state?.employees?.updateEmployee?.error;

// ✅ Delete Selectors
export const selectDeleteEmployeeData = (state) => state?.employees?.deleteEmployee?.data;
export const selectDeleteEmployeeLoading = (state) => state?.employees?.deleteEmployee?.loading;
export const selectDeleteEmployeeError = (state) => state?.employees?.deleteEmployee?.error;

// ✅ List Selectors (with pagination)
export const selectEmployeesList = (state) => state?.employees?.getEmployeesList?.data || [];
export const selectEmployeesListLoading = (state) => state?.employees?.getEmployeesList?.loading;
export const selectEmployeesListError = (state) => state?.employees?.getEmployeesList?.error;
export const selectEmployeesListTotal = (state) => state?.employees?.getEmployeesList?.total || 0;

// ✅ Get All Employees Selectors (without pagination)
export const selectEmployees = (state) => state?.employees?.getEmployees?.data || [];
export const selectEmployeesLoading = (state) => state?.employees?.getEmployees?.loading;
export const selectEmployeesError = (state) => state?.employees?.getEmployees?.error;
export const selectEmployeesTotal = (state) => state?.employees?.getEmployees?.total || 0;

// ✅ Detail Selectors
export const selectEmployeeDetail = (state) => state?.employees?.getEmployeeDetail?.data;
export const selectEmployeeDetailLoading = (state) => state?.employees?.getEmployeeDetail?.loading;
export const selectEmployeeDetailError = (state) => state?.employees?.getEmployeeDetail?.error;

// ✅ Company Employee Info Selectors
export const selectCompanyEmployeeInfo = (state) => state?.employees?.getCompanyEmployeeInfo?.data;
export const selectCompanyEmployeeInfoLoading = (state) => state?.employees?.getCompanyEmployeeInfo?.loading;
export const selectCompanyEmployeeInfoError = (state) => state?.employees?.getCompanyEmployeeInfo?.error;

// ✅ Import CSV Selectors
export const selectImportEmployeesCsvData = (state) => state?.employees?.importEmployeesCsv?.data;
export const selectImportEmployeesCsvLoading = (state) => state?.employees?.importEmployeesCsv?.loading;
export const selectImportEmployeesCsvError = (state) => state?.employees?.importEmployeesCsv?.error;

// ✅ Employee Sessions Selectors
export const selectEmployeeSessions = (state) => state?.employees?.getEmployeeSessions?.data || [];
export const selectEmployeeSessionsLoading = (state) => state?.employees?.getEmployeeSessions?.loading;
export const selectEmployeeSessionsError = (state) => state?.employees?.getEmployeeSessions?.error;
export const selectEmployeeSessionsTotal = (state) => state?.employees?.getEmployeeSessions?.total || 0;

// ✅ Session Assessment Link Selectors
export const selectSessionAssessmentLink = (state) => state?.employees?.getSessionAssessmentLink?.data;
export const selectSessionAssessmentLinkLoading = (state) => state?.employees?.getSessionAssessmentLink?.loading;
export const selectSessionAssessmentLinkError = (state) => state?.employees?.getSessionAssessmentLink?.error;

// ✅ Session Document Link Selectors
export const selectSessionDocumentLink = (state) => state?.employees?.getSessionDocumentLink?.data;
export const selectSessionDocumentLinkLoading = (state) => state?.employees?.getSessionDocumentLink?.loading;
export const selectSessionDocumentLinkError = (state) => state?.employees?.getSessionDocumentLink?.error;

// ✅ Session Assignment Result Selectors
export const selectSessionAssignmentResult = (state) => state?.employees?.getSessionAssignmentResult?.data;
export const selectSessionAssignmentResultLoading = (state) => state?.employees?.getSessionAssignmentResult?.loading;
export const selectSessionAssignmentResultError = (state) => state?.employees?.getSessionAssignmentResult?.error;

// ✅ Employee Assignments Selectors
export const selectEmployeeAssignments = (state) => state?.employees?.getEmployeeAssignments?.data || [];
export const selectEmployeeAssignmentsLoading = (state) => state?.employees?.getEmployeeAssignments?.loading;
export const selectEmployeeAssignmentsError = (state) => state?.employees?.getEmployeeAssignments?.error;

// ✅ Employee Documents Selectors
export const selectEmployeeDocuments = (state) => state?.employees?.getEmployeeDocuments?.data || { data: [], pagination: {} };
export const selectEmployeeDocumentsLoading = (state) => state?.employees?.getEmployeeDocuments?.loading;
export const selectEmployeeDocumentsError = (state) => state?.employees?.getEmployeeDocuments?.error;

// ✅ Employee Tools Selectors
export const selectEmployeeTools = (state) => state?.employees?.getEmployeeTools?.data || [];
export const selectEmployeeToolsLoading = (state) => state?.employees?.getEmployeeTools?.loading;
export const selectEmployeeToolsError = (state) => state?.employees?.getEmployeeTools?.error;

// ✅ Assignment Questions Selectors
export const selectAssignmentQuestions = (state) => state?.employees?.getAssignmentQuestions?.data;
export const selectAssignmentQuestionsLoading = (state) => state?.employees?.getAssignmentQuestions?.loading;
export const selectAssignmentQuestionsError = (state) => state?.employees?.getAssignmentQuestions?.error;

// ✅ Submit Assignment Answers Selectors
export const selectSubmitAssignmentAnswersData = (state) => state?.employees?.submitAssignmentAnswers?.data;
export const selectSubmitAssignmentAnswersLoading = (state) => state?.employees?.submitAssignmentAnswers?.loading;
export const selectSubmitAssignmentAnswersError = (state) => state?.employees?.submitAssignmentAnswers?.error;

// ✅ Assignment Answers Selectors
export const selectAssignmentAnswers = (state) => state?.employees?.getAssignmentAnswers?.data;
export const selectAssignmentAnswersLoading = (state) => state?.employees?.getAssignmentAnswers?.loading;
export const selectAssignmentAnswersError = (state) => state?.employees?.getAssignmentAnswers?.error;

// ✅ Lock/Unlock Company Employee Selectors
export const selectLockCompanyEmployeeData = (state) => state?.employees?.lockCompanyEmployee?.data;
export const selectLockCompanyEmployeeLoading = (state) => state?.employees?.lockCompanyEmployee?.loading;
export const selectLockCompanyEmployeeError = (state) => state?.employees?.lockCompanyEmployee?.error;

// ✅ Overall State Selector
export const selectEmployeesState = (state) => state?.employees;